import { render } from "./CourseCreditFeeContent.vue?vue&type=template&id=3abb06bc&scoped=true"
import script from "./CourseCreditFeeContent.vue?vue&type=script&lang=js"
export * from "./CourseCreditFeeContent.vue?vue&type=script&lang=js"

import "./CourseCreditFeeContent.vue?vue&type=style&index=0&id=3abb06bc&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abb06bc"]])

export default __exports__